/* eslint-disable operator-linebreak */
import React, { useState } from 'react';

import { CommonDropdown, ICommonDropdownOption, SearchInput } from 'pg-ui-library';

import { IBenefitListTable } from 'src/interfaces';
import { TableColumn } from 'react-data-table-component';

import useDebounceSearchTerm from 'src/hooks/useDebounceSearchTerm';
import { BenefitsColumnsSettingsButton, HeaderContainer, SearchbarContainer, TableSettingContainer } from './styles';
import { BenefitsListTable, benefitsListInitialColumns } from './components/benefits-list-table';

export const dropdownOptions1: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'Active benefits',
    value: '1',
  },
  {
    key: '2',
    label: 'Inactive benefits',
    value: '0',
  },
];

const EmployeeBenefitsTab: React.FC = () => {
  const [columns, setColumns] = useState<TableColumn<IBenefitListTable>[]>(benefitsListInitialColumns);

  // Debounce the search term so that we only perform the search
  // after the user has stopped typing for 500ms
  const { searchTerm, setSearchTerm, debouncedValue } = useDebounceSearchTerm(500);

  const [benefitStatus, setBenefitStatus] = useState<string>('1');

  return (
    <>
      <HeaderContainer />
      <SearchbarContainer>
        <CommonDropdown
          label=""
          id="benefitStatus"
          name="benefitStatus"
          value={benefitStatus}
          setValue={setBenefitStatus}
          options={dropdownOptions1}
          wrapperStyle={{ width: '10%' }}
          selectStyle={{ maxWidth: 'none', width: '100%' }}
        />
        <SearchInput
          value={searchTerm}
          placeholder="Search..."
          handleChange={event => {
            setSearchTerm(event.target.value);
          }}
        />
        <TableSettingContainer>
          <BenefitsColumnsSettingsButton columns={columns} setColumns={setColumns} />
        </TableSettingContainer>
      </SearchbarContainer>
      <BenefitsListTable key={0} activeBenefits={benefitStatus === '1'} searchTerm={debouncedValue} columns={columns} />
    </>
  );
};
export default EmployeeBenefitsTab;
